import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserPlus, UserCheck, Users } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { InstitutionMark, VerifiedBadge } from "@/components/Brand";

function Suggestion({ inst, onFollowed }) {
  const [on, setOn] = useState(false);
  const toggle = async () => {
    try {
      const { data } = await api.post(`/users/${inst.id}/follow`);
      setOn(data.following);
      onFollowed();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <li className="flex items-center gap-3 rounded-2xl bg-white/5 p-3" data-testid={`follow-suggestion-${inst.id}`}>
      <Link to={`/perfil/${inst.id}`} className="flex min-w-0 flex-1 items-center gap-3">
        <InstitutionMark name={inst.name} logo={inst.avatar_url || inst.logo_url} color={inst.brand_color} size={40} />
        <span className="truncate text-sm font-bold">{inst.name}</span>
        <VerifiedBadge size={15} />
      </Link>
      <button onClick={toggle} data-testid={`follow-suggestion-button-${inst.id}`}
        className={`inline-flex h-9 shrink-0 items-center gap-1.5 rounded-full px-4 text-xs font-extrabold transition-transform active:scale-95 ${on ? "bg-white/10" : "bg-[hsl(var(--gold))] text-[#0B0F17]"}`}>
        {on ? <><UserCheck size={14} /> Seguindo</> : <><UserPlus size={14} /> Seguir</>}
      </button>
    </li>
  );
}

export function FollowingEmpty({ onRefresh }) {
  const [insts, setInsts] = useState([]);
  const [dirty, setDirty] = useState(false);
  useEffect(() => { api.get("/institutions").then((r) => setInsts(r.data.slice(0, 6))); }, []);
  return (
    <div className="flex h-[100dvh] flex-col justify-center px-6 pb-24" data-testid="following-empty">
      <Users size={36} className="mb-4 text-[hsl(var(--gold))]" />
      <h2 className="text-2xl font-extrabold tracking-tight">Ainda não acompanha ninguém</h2>
      <p className="mt-2 text-sm text-muted-foreground">Siga igrejas e perfis para ver aqui só as publicações deles.</p>
      <ul className="mt-6 space-y-2">{insts.map((i) => <Suggestion key={i.id} inst={i} onFollowed={() => setDirty(true)} />)}</ul>
      {dirty && <button onClick={onRefresh} className="mt-5 h-11 rounded-full bg-white font-extrabold text-black" data-testid="following-refresh-button">Ver publicações</button>}
    </div>
  );
}
